import React from "react";
import { useTranslation } from "react-i18next";
import {
  CollectionListHorizontal,
  Footer,
  LinkText
} from "@common/DynamicUikit";
import { useSelector } from "react-redux";
import { CombinedReducersType } from "@redux/reducer";
import { BRAND_LIST, COUNTRY, LANGUAGE } from "@type/index";
import { getPrivacyPolicyUrl, getTermsOfUseUrl, isSP } from "@util/helpers";

const PublicFooter = () => {
  const config = useSelector((store: CombinedReducersType) => store.config);
  const { t } = useTranslation();

  const privacyPolicyUrl = getPrivacyPolicyUrl(
    config.region as COUNTRY,
    config.language as LANGUAGE,
    config.brand_name as BRAND_LIST
  );

  const termsOfUseUrl = getTermsOfUseUrl(
    config.region as COUNTRY,
    config.language as LANGUAGE,
    config.brand_name as BRAND_LIST
  );

  if (config.region === COUNTRY.AU && !config.isApp) {
    return (
      <Footer
        copyrightRow={t("text_copyright")}
        footerLinksContainer={
          <CollectionListHorizontal
            alignment="stretch"
            divider
            spacingValue={isSP() ? "16" : "8"}
          >
            <LinkText
              href={termsOfUseUrl}
              variant="standalone-secondary"
              target="_blank"
              element="a"
            >
              {t("text_termsof_conditions")}
            </LinkText>
            <LinkText
              href={privacyPolicyUrl}
              variant="standalone-secondary"
              target="_blank"
              element="a"
            >
              {t("text_privacy_policy")}
            </LinkText>
          </CollectionListHorizontal>
        }
      />
    );
  } else {
    return <Footer copyrightRow={t("text_copyright")} />;
  }
};

export default PublicFooter;
